import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, CircularProgress } from '@mui/material';

const AppRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // iOS cihaz tespiti
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = 'https://apps.apple.com/tr/app/odazen-mobil/id6753760605?l=tr';
        return;
      }

      // Android cihaz tespiti
      if (/android/i.test(userAgent)) {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.craftopya.odazen';
        return;
      }

      // Masaüstü veya diğer cihazlar - Ana sayfaya yönlendir
      setTimeout(() => {
        navigate('/');
      }, 1000);
    };

    detectDevice();
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h5" gutterBottom>
            Yönlendiriliyorsunuz...
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Cihazınıza uygun uygulama mağazasına yönlendiriliyorsunuz.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default AppRedirect;

